<template>
  <div class="card">
    <h2 class="card-header">Questions</h2>
    <div
      v-for="(question, index) in customQuestions"
      :key="index"
      class="question"
    >
      <FontAwesomeIcon
        :icon="
          question.answerStatus === 'CORRECT' ? faCheckCircle : faTimesCircle
        "
        :class="{
          'question-result--correct': question.answerStatus === 'CORRECT',
          'question-result--wrong': question.answerStatus !== 'CORRECT',
        }"
      />
      <div v-if="index !== currentIndexExpanded" class="question-query-row">
        <p class="question-query question-query--index">
          {{ `Q${index + 1}` }}
        </p>
        <p class="question-query question-query--content">
          {{ question.question }}
        </p>
      </div>
      <div v-else class="question-details">
        <div class="question-query-row question-query-row--expanded">
          <p class="question-query question-query--index">
            {{ `Q${index + 1}` }}
          </p>
          <p class="question-query question-query-content--expanded">
            {{ question.question }}
          </p>
        </div>
        <p class="question-feedback">{{ question.feedback }}</p>
        <div v-for="(option, index) in question.options" :key="index">
          <p
            class="question-option"
            :class="{
              'question-option--correct': question.correctIndex.includes(index),
              'question-option--wrong':
                !question.correctIndex.includes(index) &&
                index == question.answerSelected,
            }"
          >
            {{ option }}
          </p>
        </div>
      </div>
      <FontAwesomeIcon
        :icon="index == currentIndexExpanded ? faMinus : faPlus"
        class="question-expand-button"
        @click="expandQuestion(index)"
      />
    </div>
  </div>
</template>

<script>
import {
  faTimesCircle,
  faCheckCircle,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

export default {
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      faTimesCircle,
      faCheckCircle,
      faMinus,
      faPlus,
      selectedItemIndex: -1,
    };
  },
  computed: {
    currentIndexExpanded: {
      get() {
        return this.selectedItemIndex;
      },
      set(value) {
        this.selectedItemIndex = value;
      },
    },
    customQuestions() {
      return this.questions;
    },
  },
  methods: {
    expandQuestion(index) {
      index === this.currentIndexExpanded
        ? (this.currentIndexExpanded = -1)
        : (this.currentIndexExpanded = index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";

.card {
  background: $quaternary-darker;
  border: 0.25px solid #a3a3a3;
  box-sizing: border-box;
  box-shadow: 0px 37.4993px 97.0944px rgba(0, 0, 0, 0.0413989);
  border-radius: 10px;
  margin: 1rem;
  padding: 0;
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card-header {
  margin: 0 0 0.7rem;
  font-family: $secondary-font;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  align-self: center;

  color: $secondary-darker;
}

.question {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  padding: 1rem 0;
  margin: 0 0.5rem;
  border-bottom: 1px solid $primary;
}

.question:last-child {
  border-bottom: none;
}

.question-query-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  width: 80%;
}

.question-query-row--expanded {
  width: 100%;
}

.question-query {
  font-family: $primary-font;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: $primary;
  margin: 0 0.5rem;
}

.question-query--content {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.question-query--index {
  margin-right: 0.3rem;
}

.question-query-content--expanded {
  font-style: normal;
  font-weight: bold;
  margin: 0;
}

.question-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: baseline;
}

.question-feedback {
  font-family: $primary-font;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: $primary;
  margin-left: 2rem;
}

.question-option {
  font-family: $primary-font;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: $quinternary-darker;
  margin: 0.2rem 2rem 0;
}

.question-option--correct {
  font-weight: 800;
  color: $secondary-darker;
}

.question-option--wrong {
  font-weight: 800;
  color: $tertiary-darker;
}

.question-result--correct {
  background: $secondary-darker;
  color: $secondary-lighter;
  border: 2px solid $secondary-darker;
  border-radius: 20px;
}

.question-result--wrong {
  background: $tertiary-darker;
  color: $tertiary-lighter;
  border: 2px solid $tertiary-darker;
  border-radius: 20px;
}

.question-expand-button {
  color: $secondary-darker;
}
</style>
